import React from "react";
import Sprite from "./Img/numer_input_sprite.svg";
import ImageSprite from "../../ImageSprite/ImageSprite";
import "./NumberInput.scss";

interface NumberInputBaseProps {
    label?: string;
    value: number;
    min: number;
    max: number;
    disabled?: boolean;
    readOnly?: boolean;
    error?: string | null;
    onChange: (value: number) => void;
}

const NumberInputBase: React.FC<NumberInputBaseProps> = ({
    label,
    value,
    min,
    max,
    disabled,
    readOnly,
    error,
    onChange,
}) => {
    const handleIncrement = (e: React.MouseEvent) => {
        e.preventDefault();
        if (value < max) onChange(value + 1);
    };

    const handleDecrement = (e: React.MouseEvent) => {
        e.preventDefault();
        if (value > min) onChange(value - 1);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value;

        if (raw === "") {
            onChange(min);
            return;
        }

        if (raw === "0") {
            onChange(min);
            return;
        }

        const cleaned = raw.replace(/^0+/, "");
        const num = Number(cleaned);

        if (isNaN(num)) return;

        if (num < min) onChange(min);
        else if (num > max) onChange(max);
        else onChange(num);
    };

    return (
        <div
            className={`  ${error ? "invalid" : "valid"}`}
            aria-disabled={disabled}
        >
            {label && <label className="label">{label}</label>}

            <div className="number_input">
                <button
                    className="number_input__button"
                    onClick={handleDecrement}
                    disabled={readOnly || disabled}
                >
                    <ImageSprite iconSprite={`${Sprite}#minus`} />
                </button>

                <input
                    type="number"
                    className="number_input__input form_control__input"
                    readOnly={readOnly}
                    disabled={disabled}
                    value={value}
                    min={min}
                    max={max}
                    pattern="[0-9]*"
                    onChange={handleChange}
                />

                <button
                    className="number_input__button"
                    onClick={handleIncrement}
                    disabled={readOnly || disabled}
                >
                    <ImageSprite iconSprite={`${Sprite}#plus`} />
                </button>
            </div>

            {error && <div className="form_control__error">{error}</div>}
        </div>
    );
};

export default NumberInputBase;
